import { createParser } from 'nuqs';

/**
 * Parser for comma-separated string arrays in URL query params.
 * e.g. ?tags=id1,id2,id3
 */
export const parseAsStringArray = createParser<string[]>({
  parse(queryValue) {
    if (!queryValue) return null;
    return queryValue.split(',').filter(Boolean);
  },
  serialize(value) {
    if (!value || value.length === 0) return '';
    return value.join(',');
  },
  eq(a, b) {
    if (!a && !b) return true;
    if (!a || !b) return false;
    return a.length === b.length && a.every((v, i) => v === b[i]);
  },
});

/**
 * Parser for JSON-encoded arrays in URL query params.
 * Values are URI-encoded JSON strings.
 * e.g. ?sort=%5B%7B%22id%22%3A%22name%22%2C%22desc%22%3Afalse%7D%5D
 */
export const parseAsJsonArray = createParser<any[]>({
  parse(queryValue) {
    try {
      const decoded = decodeURIComponent(queryValue);
      const parsed = JSON.parse(decoded);
      return Array.isArray(parsed) ? parsed : null;
    } catch {
      return null;
    }
  },
  serialize(value) {
    const jsonString = JSON.stringify(value);
    return encodeURIComponent(jsonString);
  },
  eq(a, b) {
    return JSON.stringify(a) === JSON.stringify(b);
  },
});

/**
 * Parser for a simple nullable string value.
 * Equivalent to calendarViewParser / venueParser / calendarDateParser patterns.
 */
export const parseAsNullableString = createParser<string>({
  parse(queryValue) {
    return queryValue ?? null;
  },
  serialize(value) {
    return value ?? '';
  },
  eq(a, b) {
    return a === b;
  },
});
